import React, { useEffect } from 'react';
import Button from 'src/components/10-atoms/button/Button';
import Field from 'src/components/10-atoms/form/Field';
import { getFieldError } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import TagsInput from 'src/components/10-atoms/form/inputs/TagsInput';
import TextInput from 'src/components/10-atoms/form/inputs/TextInput';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import { snackbarHelperActions } from 'src/components/20-helper-views/snackbar/useSnackbar';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
import useData from './useData';
const NoteFormDrawer = ({ note, draftApply, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData(note, draftApply);
    const isEditMode = !!note;
    const isLoading = state.draftOnly
        ? false
        : state.createMutation.loading || state.updateMutation.loading;
    useEffect(() => {
        if (state.draftOnly) {
            return;
        }
        if (state.createMutation.data || state.updateMutation.data) {
            bottomDrawerHelperActions.hide();
            snackbarHelperActions.show({
                variant: 'POSITIVE',
                duration: 'SHORT',
                message: isEditMode ? translate('Note updated successfully') : translate('Note created successfully'),
            });
        }
    }, [state.createMutation.data, state.draftOnly, state.updateMutation.data]);
    return (React.createElement(BottomDrawerLayout, null,
        React.createElement(BottomDrawerLayout.Title, null, isEditMode ? 'Edit Note' : 'Create Note'),
        React.createElement(BottomDrawerLayout.ScrollableBody, null,
            React.createElement(Field, { label: "Title", error: getFieldError(state.form.fields.title.errors) },
                React.createElement(TextInput, { autoFocus: !isEditMode, placeholder: "Enter note title", value: state.form.fields.title.value, onChange: actions.form.fields.title.setValue, maxLength: 200, editable: !isLoading })),
            React.createElement(Field, { label: "Topics", error: getFieldError(state.form.fields.topics.errors) },
                React.createElement(TagsInput, { value: state.form.fields.topics.value, onChange: actions.form.fields.topics.setValue, input: state.form.fields.topicsInput.value, onInputChange: actions.form.fields.topicsInput.setValue, placeholder: "Add topics", disabled: isLoading }))),
        React.createElement(BottomDrawerLayout.Actions, { btw: 1, spacing: theme.spacing.standard.md, pv: theme.spacing.standard.sm },
            React.createElement(Button, { loading: isLoading, flex: true, onPress: actions.handleSubmit }, isEditMode ? 'Update' : 'Create'))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({}));
export default NoteFormDrawer;
